
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store";

// Vendors
import moment from "moment";

// Models
import {AdministratorPlayersProfileTrainingsListIndex} from "@/models/app/administrator/players/profile/trainings/list/index";
import {AppCommonTrainingCategory} from "@/models/app/common/training-category";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AdministratorPlayersProfileTrainingsListFormCreateIndexVue from "@/views/app/administrator/players/profile/trainings/list/form/create.vue";
import AdministratorPlayersProfileTrainingsListFormUpdateIndexVue from "@/views/app/administrator/players/profile/trainings/list/form/update.vue";
import AdministratorPlayersProfileTrainingsListFormRemoveIndexVue from "@/views/app/administrator/players/profile/trainings/list/form/remove.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  props: [
    "trainingCategories",
  ],
  components: {
    ElRow,
    ElCol,
    AdministratorPlayersProfileTrainingsListFormCreateIndexVue,
    AdministratorPlayersProfileTrainingsListFormUpdateIndexVue,
    AdministratorPlayersProfileTrainingsListFormRemoveIndexVue,
  },
})
export default class AdministratorPlayersProfileTrainingsListIndexVue extends Vue {
  isLoading: boolean | null = false;

  formData: any = {
    filter: {
      user_id: "*",
      training_category_id: "*",
      date: [
        moment(),
        moment().add(14, "days"),
      ],
    },
    organization_id: store.getters.getOrganizationMember.organization_id,
  };

  moment: any = null;

  trainingCategories: Array<AppCommonTrainingCategory> = [];

  trainings: Array<AdministratorPlayersProfileTrainingsListIndex> = [];

  async getTrainings(formData: any = null): Promise<void> {
    this.isLoading = true;

    if (formData) {
      this.formData = formData;
    }

    await getRequest({
      uri: `/common/trainings`,
      formData: this.formData,
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.trainings = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    this.moment = moment;
    this.formData.filter.user_id = this.$route.params.id;
    await this.getTrainings();
  }
}
